import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { APP_ENV_CONFIG } from '@shared/services';

@Component({
  selector: 'app-environment-banner',
  templateUrl: './environment-banner.component.html',
  styleUrls: ['./environment-banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class EnvironmentBannerComponent {
  private readonly envConfig = inject(APP_ENV_CONFIG);

  // Key off the env name, not the `production` flag: `sandbox` is flagged
  // production: true but must still display the testing banner.
  readonly show = this.envConfig.name !== 'production';
}
